import { FC } from 'react';
import { IResponseRegisteredAppInfo } from '@models/manager/service/serviceModel';

const SelectedAppList: FC<{
  myAppObj: IResponseRegisteredAppInfo | null;
  selectedAppList: IResponseRegisteredAppInfo[];
  onClickSelectApp: (item: IResponseRegisteredAppInfo) => void;
}> = ({ myAppObj, selectedAppList, onClickSelectApp }) => {
  return (
    <>
      <div className="app-info app-sugg">
        <div className="keyword-data-tit">MyApp</div>

        {!!myAppObj && (
          <div className="myapp">
            <div className="myapp-img">
              <img src={myAppObj.icon} />
            </div>
            <div className="myapp-txt">
              <h2 className="myapp-tit">{myAppObj.title}</h2>
              <p className="myapp-dsc">{myAppObj.developer}</p>
            </div>
          </div>
        )}
      </div>
      <div className="app-info app-sugg">
        <div className="keyword-data-tit">CompetitorApps</div>
        <div className="search-app">
          <ul className="chart-ranking-data">
            {selectedAppList.length > 0 && (
              <>
                {selectedAppList.map((appObj, index) => (
                  <li key={`${appObj.appId}_${appObj.provider_type}`}>
                    <div className="game-img">
                      <img src={appObj.icon} />
                    </div>
                    <div className="game-info">
                      <p className="game-tit">{appObj.title}</p>
                      <p className="game-desc">{appObj.developer}</p>
                    </div>
                    <button type="button" className="btn-ico-single app-del" onClick={() => onClickSelectApp(appObj)}>
                      <span className="blind">삭제</span>
                    </button>
                  </li>
                ))}
              </>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SelectedAppList;
